var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "wa-modal-frame",
        {
          attrs: {
            title: "Icon Detail Modal",
            "component-class": "icon-detail",
            "is-showing": _vm.isShowing && !_vm.isShowingUpsellModal,
          },
          on: {
            "close-modal": function ($event) {
              return _vm.closeModal()
            },
          },
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }),
          _vm._v(" "),
          _c(
            "template",
            { slot: "content" },
            [
              _vm.isShowingUpsellModal == false
                ? [
                    _vm.hasIcon
                      ? _c(
                          "div",
                          {
                            staticClass: "wrap-icon-detail",
                            attrs: { id: `icon-detail-${_vm.icon.label}` },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "icon-detail card roomy margin-bottom-0 with-close text-left",
                              },
                              [
                                _vm.display == "detail"
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "row roomy laptop:align-stretch laptop:align-between margin-bottom-lg",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "column-12 laptop:column",
                                            },
                                            [
                                              _c("icon-name-and-link", {
                                                attrs: {
                                                  "default-styles":
                                                    _vm.defaultStyles,
                                                  icon: _vm.isCustomIcon
                                                    ? _vm.customIcon
                                                    : _vm.icon,
                                                  "is-pro-user": _vm.isProUser,
                                                  "is-pro-icon": _vm.isProIcon,
                                                  "is-using-modal": true,
                                                  styling: _vm.styling,
                                                },
                                                on: {
                                                  openProIconModal:
                                                    _vm.openProIconModal,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "column-12 laptop:column display-flex flex-row flex-nowrap flex-items-center laptop:flex-content-end",
                                              staticStyle: {
                                                gap: "var(--spacing-md)",
                                              },
                                            },
                                            [
                                              _c("icon-unicodes", {
                                                attrs: {
                                                  icon: _vm.isCustomIcon
                                                    ? _vm.customIcon
                                                    : _vm.icon,
                                                  "is-duotone": _vm.isDuotone,
                                                  "is-using-modal": true,
                                                  styling: _vm.styling,
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("icon-glyphs", {
                                                attrs: {
                                                  icon: _vm.isCustomIcon
                                                    ? _vm.customIcon
                                                    : _vm.icon,
                                                  "is-duotone": _vm.isDuotone,
                                                  "is-custom-icon":
                                                    _vm.isCustomIcon,
                                                  "is-using-modal": true,
                                                  styling: _vm.styling,
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("icon-svg-download", {
                                                attrs: {
                                                  "can-access-icon":
                                                    _vm.canAccessIcon,
                                                  "can-download-icon":
                                                    _vm.canDownloadIcon,
                                                  icon: _vm.isCustomIcon
                                                    ? _vm.customIcon
                                                    : _vm.icon,
                                                  "is-pro-icon": _vm.isProIcon,
                                                  "is-pro-user": _vm.isProUser,
                                                  "is-custom-icon":
                                                    _vm.isCustomIcon,
                                                  "is-using-modal": true,
                                                  styling: _vm.styling,
                                                  viggo: _vm.viggo,
                                                },
                                                on: {
                                                  openProIconModal:
                                                    _vm.openProIconModal,
                                                  getSelectedAction:
                                                    _vm.getSelectedAction,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "wrap-icon-details row roomy align-stretch laptop:margin-bottom-2xl",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "icon-detail-grid-preview column-12 margin-bottom-2xl laptop:margin-bottom-0 laptop:column-6",
                                            },
                                            [
                                              _c("icon-preview", {
                                                attrs: {
                                                  "default-styles":
                                                    _vm.defaultStyles,
                                                  icon: _vm.isCustomIcon
                                                    ? _vm.customIcon
                                                    : _vm.icon,
                                                  "is-custom-icon":
                                                    _vm.isCustomIcon,
                                                  "is-duotone": _vm.isDuotone,
                                                  "preview-mode":
                                                    _vm.previewMode,
                                                  styling: _vm.styling,
                                                  version: _vm.version,
                                                  "display-icon-preview-controls": true,
                                                },
                                                on: {
                                                  resetStyles: function (
                                                    $event
                                                  ) {
                                                    return _vm.$emit(
                                                      "resetStyles"
                                                    )
                                                  },
                                                  changePreviewMode: (mode) =>
                                                    (_vm.previewMode = mode),
                                                  toggleStyleOptions:
                                                    _vm.toggleStyleOptions,
                                                  toggleAnimationOptions:
                                                    _vm.toggleAnimationOptions,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "icon-detail-use column-12 laptop:column-6 margin-bottom-2xl laptop:margin-bottom-0",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "margin-bottom-2xl",
                                                },
                                                [
                                                  !_vm.isCustomIcon
                                                    ? _c("icon-pack-selector", {
                                                        attrs: {
                                                          icon: _vm.icon,
                                                          styling: _vm.styling,
                                                          version: _vm.version,
                                                          "default-styles":
                                                            _vm.defaultStyles,
                                                        },
                                                        on: {
                                                          change: (
                                                            newStyling
                                                          ) =>
                                                            _vm.$emit(
                                                              "stylingChange",
                                                              newStyling
                                                            ),
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("icon-code-snippet", {
                                                attrs: {
                                                  id: _vm.icon.name,
                                                  "can-access-icon":
                                                    _vm.canAccessIcon,
                                                  "can-download-icon":
                                                    _vm.canDownloadIcon,
                                                  "default-styles":
                                                    _vm.defaultStyles,
                                                  icon: _vm.isCustomIcon
                                                    ? _vm.customIcon
                                                    : _vm.icon,
                                                  "icon-abstract":
                                                    _vm.iconAbstract,
                                                  "is-custom-icon":
                                                    _vm.isCustomIcon,
                                                  "is-duotone": _vm.isDuotone,
                                                  "is-pro-icon": _vm.isProIcon,
                                                  "is-pro-user": _vm.isProUser,
                                                  "is-using-modal": true,
                                                  "kit-version": _vm.kitVersion,
                                                  showing: _vm.showing,
                                                  styling: _vm.styling,
                                                  viggo: _vm.viggo,
                                                },
                                                on: {
                                                  show: _vm.changeShowing,
                                                  openProIconModal:
                                                    _vm.openProIconModal,
                                                  getSelectedAction:
                                                    _vm.getSelectedAction,
                                                },
                                              }),
                                              _vm._v(" "),
                                              !_vm.isTemporarilyDisabled
                                                ? _c("icon-actions", {
                                                    attrs: {
                                                      "can-access-icon":
                                                        _vm.canAccessIcon,
                                                      "can-use-icon":
                                                        _vm.canUseIcon,
                                                      icon: _vm.isCustomIcon
                                                        ? _vm.customIcon
                                                        : _vm.icon,
                                                      "is-custom-icon":
                                                        _vm.isCustomIcon,
                                                      "is-pro-icon":
                                                        _vm.isProIcon,
                                                      "is-pro-plus-icon":
                                                        _vm.isProPlusIcon(
                                                          _vm.icon
                                                        ),
                                                      "is-pro-user":
                                                        _vm.isProUser,
                                                      "is-using-modal": true,
                                                      styling: _vm.styling,
                                                    },
                                                    on: {
                                                      editIcon: function (
                                                        $event
                                                      ) {
                                                        _vm.display = "edit"
                                                      },
                                                      getSelectedAction:
                                                        _vm.getSelectedAction,
                                                      openProIconModal:
                                                        _vm.openProIconModal,
                                                      showConfirmDelete:
                                                        _vm.showConfirmDelete,
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.isDeleting
                                                ? _c("confirm-delete", {
                                                    attrs: {
                                                      "delete-inprocess":
                                                        _vm.deleteInprocess,
                                                    },
                                                    on: {
                                                      hideConfirmDelete:
                                                        function ($event) {
                                                          return _vm.hideConfirmDelete()
                                                        },
                                                      deleteIcon:
                                                        _vm.deleteIcon,
                                                    },
                                                  })
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "icon-detail-styling-tabs column-12",
                                            },
                                            [
                                              _c("icon-styling", {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.isShowingStyleOptions,
                                                    expression:
                                                      "isShowingStyleOptions",
                                                  },
                                                ],
                                                attrs: {
                                                  "default-styles":
                                                    _vm.defaultStyles,
                                                  icon: _vm.isCustomIcon
                                                    ? _vm.customIcon
                                                    : _vm.icon,
                                                  styling: _vm.styling,
                                                  version: _vm.version,
                                                },
                                                on: {
                                                  change: (newStyling) =>
                                                    _vm.$emit(
                                                      "stylingChange",
                                                      newStyling
                                                    ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("icon-animations", {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.isShowingAnimationOptions,
                                                    expression:
                                                      "isShowingAnimationOptions",
                                                  },
                                                ],
                                                attrs: {
                                                  icon: _vm.isCustomIcon
                                                    ? _vm.customIcon
                                                    : _vm.icon,
                                                  styling: _vm.styling,
                                                  version: _vm.version,
                                                },
                                                on: {
                                                  change: (newStyling) =>
                                                    _vm.$emit(
                                                      "stylingChange",
                                                      newStyling
                                                    ),
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.isBrandsIcon
                                        ? _c("icon-brand-notice")
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isSponsored
                                        ? _c("icon-sponsorship", {
                                            attrs: {
                                              "sponsor-name":
                                                _vm.icon.sponsored.label,
                                              "sponsor-url":
                                                _vm.icon.sponsored.url,
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "row roomy align-middle align-center margin-top-md",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "display-flex",
                                              staticStyle: {
                                                gap: "var(--spacing-md)",
                                                "flex-wrap": "wrap",
                                                "justify-content": "center",
                                              },
                                            },
                                            [
                                              _vm.hasCategories
                                                ? _c("icon-categories", {
                                                    attrs: {
                                                      categories:
                                                        _vm.icon.categories,
                                                      icon: _vm.icon,
                                                      "is-using-modal": true,
                                                    },
                                                    on: {
                                                      closeModal:
                                                        _vm.closeModal,
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.hasAliases
                                                ? _c("icon-aliases", {
                                                    attrs: {
                                                      aliases:
                                                        _vm.icon.aliases.names,
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("icon-version-info", {
                                                attrs: {
                                                  icon: _vm.isCustomIcon
                                                    ? _vm.customIcon
                                                    : _vm.icon,
                                                  "is-custom-icon":
                                                    _vm.isCustomIcon,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.display == "edit"
                                  ? _c(
                                      "div",
                                      [
                                        _c("icon-customize", {
                                          attrs: {
                                            "default-styles": _vm.defaultStyles,
                                            icon: _vm.icon,
                                            "is-pro-user": _vm.isProUser,
                                            "is-using-modal": true,
                                            "selected-family": _vm.icon.family,
                                            "selected-style": _vm.icon.style,
                                            styling: _vm.styling,
                                            version: _vm.version,
                                          },
                                          on: {
                                            closeEditor: _vm.closeEditor,
                                            change: (newStyling) =>
                                              _vm.$emit(
                                                "stylingChange",
                                                newStyling
                                              ),
                                            getSelectedAction:
                                              _vm.getSelectedAction,
                                            openProIconModal:
                                              _vm.openProIconModal,
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "display-none tablet:display-inline-block flat",
                                      staticStyle: {
                                        "--button-color": "var(--fa-gravy)",
                                        position: "absolute",
                                        top: "var(--icon-details-preview-arrows-top)",
                                        left: "calc(-1 * var(--spacing-7xl))",
                                        "--button-background": "transparent",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.prevIcon.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: {
                                          icon: _vm.$v6.regular.faAngleLeft,
                                          size: "4x",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "sr-only" }, [
                                        _vm._v("Previous Icon"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "display-none tablet:display-inline-block flat",
                                      staticStyle: {
                                        "--button-color": "var(--fa-gravy)",
                                        position: "absolute",
                                        top: "var(--icon-details-preview-arrows-top)",
                                        right: "calc(-1 * var(--spacing-7xl))",
                                        "--button-background": "transparent",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.nextIcon.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: {
                                          icon: _vm.$v6.regular.faAngleRight,
                                          size: "4x",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "sr-only" }, [
                                        _vm._v("Next Icon"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              2
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        2
      ),
      _vm._v(" "),
      !_vm.canAccessIcon
        ? _c("wa-modal-upsell", {
            attrs: {
              icon: _vm.isCustomIcon ? _vm.customIcon : _vm.icon,
              "is-custom-icon": _vm.isCustomIcon,
              "is-showing": _vm.isShowingUpsellModal,
              "upsell-requirement": _vm.upsellRequirement,
              "upsell-trigger": _vm.getSelectedAction(_vm.selectedAction),
              "upsell-trigger-icon-name": _vm.selectedActionIcon,
            },
            on: { "close-modal": _vm.closeProIconModal },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }